import DesAccordion from './DesAccordion';
import DesAccordionSection from './DesAccordionSection';

export * from './DesAccordion.types';
export { DesAccordion, DesAccordionSection };
